import { Center, Link } from "@chakra-ui/react";
import NextLink from "next/link";
import { Layout } from "ui/src/components/HomeDomain/Layout";
import { MainHero } from "ui/src/components/HomeDomain/MainHero";

const Custom404Page = () => (
  <Layout
    title="404 Not Found | TheLastWeekIn.dev"
    alertTitle="TLWI.dev is undergoing changes!"
    alertDescription="Bear with us as we make our updates for the better"
  >
    <MainHero byline="Oh noessss! This page is just some 404 kafuffle." />
    <Center p={8}>
      <Link as={NextLink} href="/" color="blue.500" fontSize="xl">
        Dev human phone home
      </Link>
    </Center>
  </Layout>
);

export default Custom404Page;
